// extracted by css-extract-rspack-plugin
export default {"spacer":"_6b3bab31","originalListPrice":"_9c1dc171","reducedPrice":"_b288af8e"};